export default {
  name: "light",
  brand: {
    primary: "#277661",
    secondary: "#29DEAE",
    hover: "#29c59c",
    progress: "#2ad0a4",
    contrast: "#fff",
    soft: "rgba(41, 219, 172, 0.1)",
    primarySoft: "rgba(39, 118, 97, 0.5)",
    logoFilter: "none",
    gradient: "linear-gradient(40deg, #29DEAE -20.66%, #277661 68.48%)",
    gradientReverse: "linear-gradient(40deg, #277661 -20%, #29DEAE 70%)",
    gradientBar: "linear-gradient(100deg, #277661 -20.66%, #29DEAE 68.48%)",
  },
  body: {
    background: "#F5F4FA",
    color: "#909090",
  },
  text: {
    primary: "#162954",
    secondary: "#909090",
    muted: "#5a5a5a",
    inverse: "#fff",
  },
  surface: {
    background: "#fff",
    muted: "#F5F4FA",
    hover: "#F5F4FA",
    border: "#E5E5E5",
    divider: "#E5E5E5",
    shadow: "#C4C4C4",
    selected: "#e9f3f0",
    borderSoft: "rgba(229, 229, 229, 0.5)",
    subtle: "rgba(229, 227, 236, 0.5)",
    faint: "rgba(245, 244, 250, 0.25)",
    loadingOverlay: "rgba(255, 255, 255, 0.8)",
    spinnerOverlay: "rgba(255, 255, 255, 0.75)",
    spinnerGradient: "linear-gradient(0deg, rgba(255, 255, 255, 0.85) 55%, rgba(255, 255, 255, 0) 100%)",
  },
  link: {
    color: "#277661",
    hover: "#277661",
  },
  scrollbar: {
    track: "#CEEBE4",
    thumb: "linear-gradient(40deg, #29DEAE -20.66%, #277661 68.48%)",
    softTrack: "#F5F4FA",
    softThumb: "#b9bccc",
  },
  header: {
    background: "#e5e3ec",
    buttonColor: "#fff",
    buttonBackground: "rgba(22, 41, 84, 0.3)",
    buttonHoverBackground: "rgba(22, 41, 84, 0.8)",
    userPhotoBackground: "#fff",
    userPhotoShadow: "rgba(84, 99, 132, 0.3)",
    userPhotoShadowMobile: "rgba(84, 99, 132, 0.2)",
    userInitialColor: "#162954",
    userNameColor: "#162954",
    userRoleColor: "rgba(22, 41, 84, 0.75)",
    dropdownButtonColor: "#162954",
    dropdownButtonIdleColor: "#162954",
    dropdownButtonHoverBackground: "rgba(0, 0, 0, 0.04)",
    dropdownItemColor: "#5a5a5a",
    dropdownIconColor: "#162954",
    burgerColor: "#909090",
    burgerMobileColor: "#162954",
  },
  sidebar: {
    background: "#fff",
    itemColor: "#909090",
    itemHoverBackground: "#F5F4FA",
    activeColor: "#277661",
    activeBackground: "#F5F4FA",
    activeBar: "linear-gradient(100deg, #277661 -20.66%, #29DEAE 68.48%)",
    logoColor: "#162954",
    scrollTrack: "#F5F4FA",
    scrollThumb: "#b9bccc",
  },
  menu: {
    background: "#fff",
    color: "#909090",
    hoverBackground: "#F5F4FA",
  },
  table: {
    headColor: "#162954",
    border: "#E5E5E5",
    rowHoverColor: "#277661",
    rowHoverBackground: "#F5F4FA",
    actionInfoHover: "#1c46a7",
    actionDangerHover: "#e40d25",
  },
  tabs: {
    titleColor: "#277661",
    activeColor: "#277661",
    activeBackground: "#F5F4FA",
    hoverBackground: "#F5F4FA",
    indicator: "#29c59c",
    border: "#E5E5E5",
  },
  overlay: {
    hover: "rgba(0, 0, 0, 0.04)",
    divider: "rgba(0, 0, 0, 0.12)",
    border: "rgba(0, 0, 0, 0.23)",
    underline: "rgba(0, 0, 0, 0.42)",
    underlineHover: "rgba(0, 0, 0, 1)",
    accentSoft: "rgba(22, 41, 84, 0.05)",
    accentMedium: "rgba(22, 41, 84, 0.1)",
    accentStrong: "rgba(22, 41, 84, 0.3)",
  },
  input: {
    color: "#000",
    labelColor: "rgba(0, 0, 0, 0.54)",
    labelActiveColor: "#162954",
    selectLabelColor: "#7e7e7e",
    borderColor: "rgba(0, 0, 0, 0.42)",
    borderHoverColor: "#162954",
    borderFocusColor: "#162954",
    focusUnderline: "#3f51b5",
    iconColor: "#7d7d7d",
    errorColor: "red",
    autofillBackground: "rgb(233 232 237)",
  },
  button: {
    primary: "linear-gradient(40deg, #3f51b5 30%, #62a0fe 90%)",
    success: "linear-gradient(40deg, #277661 -20%, #29DEAE 70%)",
    danger: "linear-gradient(40deg, #FF0000 30%, #FB4B6B 90%)",
    warning: "linear-gradient(40deg, #FF7A00 30%, #FFBB38 90%)",
    contrast: "#fff",
    transparentColor: "#277661",
  },
  switch: {
    color: "#909090",
    trackColor: "#909090",
    checkedColor: "#29c59c",
    checkedHoverBackground: "rgba(41, 197, 156, 0.1)",
  },
  checkbox: {
    color: "#909090",
    checkedColor: "#277661",
    hoverBackground: "rgb(164 164 164 / 10%)",
    checkedHoverBackground: "rgba(41, 197, 156, 0.1)",
  },
  pagination: {
    itemColor: "#909090",
    selectedColor: "#ffffff",
    selectedBackground: "linear-gradient(40deg, #277661 -20%, #29DEAE 70%)",
  },
  stepper: {
    activeColor: "#277661",
    completedColor: "rgba(39, 118, 97, 0.5)",
  },
  dialog: {
    background: "#fff",
    headColor: "#162954",
    closeHoverBackground: "#F5F4FA",
  },
  filter: {
    dropdownBackground: "#fff",
    dropdownShadow: "0 5px 5px -3px rgb(0 0 0 / 20%), 0 8px 10px 1px rgb(0 0 0 / 14%), 0 3px 14px 2px rgb(0 0 0 / 12%)",
    blockBackground: "rgba(245, 244, 250, 0.5)",
    titleColor: "#277661",
    chipColor: "#000",
    chipBorder: "rgba(0, 0, 0, 0.23)",
    chipHoverBackground: "rgba(0, 0, 0, 0.04)",
    clearColor: "#FB4B6B",
    clearHoverBackground: "rgba(251, 75, 107, 0.08)",
    closeColor: "#909090",
    itemsPerPageBackground: "#fff",
    submitColor: "rgb(255, 255, 255)",
    submitBackground: "linear-gradient(40deg, rgb(39, 118, 97) -20%, rgb(41, 222, 174) 70%)",
  },
  status: {
    danger: "linear-gradient(40deg, #FF0000 30%, #FB4B6B 90%)",
    frozen: "linear-gradient(40deg, #c62828 30%, #f44336 90%)",
    warning: "linear-gradient(40deg, #FF7A00 30%, #FFBB38 90%)",
    success: "linear-gradient(40deg, #277661 -20%, #29DEAE 70%)",
    cancelled: "linear-gradient(40deg, #4f4f4f 30%, #a3a3a3 90%)",
    default: "linear-gradient(40deg, #3f51b5 30%, #62a0fe 90%)",
    color: "#fff",
  },
  state: {
    danger: "#FB4B6B",
    warning: "#FFBB38",
    success: "#29DEAE",
    info: "#62a0fe",
    error: "#f44336",
  },
  badge: {
    successColor: "#1e4620",
    successBackground: "#edf7ed",
    dangerColor: "#5f2120",
    dangerBackground: "#fdeded",
    neutralColor: "#5e5e5e",
    neutralBackground: "#f5f5f5",
  },
  iconButton: {
    successColor: "#45CAA7",
    successBorder: "#29DE67",
    successBackground: "rgba(41, 219, 172, 0.1)",
    dangerColor: "#FB4B6B",
    dangerBorder: "#de2929",
    dangerBackground: "rgba(219, 41, 41, 0.1)",
  },
};